import { render, staticRenderFns } from "./ManageRatePlans.vue?vue&type=template&id=3609e804&scoped=true&"
import script from "./ManageRatePlans.vue?vue&type=script&lang=js&"
export * from "./ManageRatePlans.vue?vue&type=script&lang=js&"
import style0 from "./ManageRatePlans.vue?vue&type=style&index=0&id=3609e804&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3609e804",
  null
  
)

export default component.exports